import { SQLGeneratedProcess } from "@avenueops/shared-types";
import { Badge } from "@avenueops/web-components";

interface Props {
  row: SQLGeneratedProcess;
}

export default function HasSendingErrors({ row }: Props): JSX.Element {
  return (
    <Badge type={row.hasSendingErrors ? "URGENT" : "DEFAULT"} size="SMALL">
      {row.hasSendingErrors ? "true" : "false"}
    </Badge>
  );
}
